import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { MaintenanceCommandsComponent } from './maintenance-commands/maintenance-commands.component';
import { MaintenanceComponentsComponent } from './maintenance-components/maintenance-components.component';
import { MaintenanceFailedTestsComponent } from './maintenance-failed-tests/maintenance-failed-tests.component';
import { MaintenanceLinksComponent } from './maintenance-links/maintenance-links.component';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { MaintenanceScheduleComponent } from './maintenance-schedule/maintenance-schedule.component';
import { AddTaskDialogComponent } from './maintenance-tasks/add-task/add-task-dialog/add-task-dialog.component';
import { MaintenanceTasksComponent } from './maintenance-tasks/maintenance-tasks.component';
import { MaintenanceTestCommandInputComponent } from './maintenance-test-command-input/maintenance-test-command-input.component';
import { MaintenanceTestCommandsComponent } from './maintenance-test-commands/maintenance-test-commands.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MaintenanceEffects } from './store/maintenance.effects';
import * as fromMaintenance from './store/maintenance.reducers';

// NOTE: not used
// Included in wireframes but not included in final product at the moment
// Only test command components are used for now
// The other components are left in the project because the code might be useful in the future

// Components used:
// -  Maintenance Test Commands
// -  Maintenance Test Input Commands

// Components not used:
// -  Maintenance Commands
// -  Maintenance Components
// -  Maintenance Failed Tests
// -  Maintenance Links
// -  Maintenance Mode
// -  Maintenance Schedule
// -  Maintenance Tasks
// -  Maintenance Tasks

const maintenanceRoutes: Routes = [
    { path: Pages.maintenance.path, component: MaintenanceComponent },
    { path: '**', component: MaintenanceComponent }
];

@NgModule({
    declarations: [
        MaintenanceComponent,
        MaintenanceModeComponent,
        MaintenanceLinksComponent,
        MaintenanceCommandsComponent,
        MaintenanceFailedTestsComponent,
        MaintenanceComponentsComponent,
        MaintenanceScheduleComponent,
        MaintenanceTasksComponent,
        MaintenanceTestCommandsComponent,
        AddTaskDialogComponent,
        MaintenanceTestCommandInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        LocationContextPanelModule,
        NotificationsModule,
        RouterModule.forChild(maintenanceRoutes),
        StoreModule.forFeature(fromMaintenance.maintenanceFeatureKey, fromMaintenance.maintenanceModeContextReducer, {
            metaReducers: fromMaintenance.metaReducers
        }),
        EffectsModule.forFeature([MaintenanceEffects])
    ]
})
export class MaintenanceModule {}
